import React from "react";
import * as Animate from "react-reveal";

import AccImage1 from "../../../assets/images/png/home/accelerate1.webp";
import AccImage2 from "../../../assets/images/png/home/accelerate2.webp";

import AccImage3 from "../../../assets/images/png/home/accelerate-inverse-1.webp";
import AccImage4 from "../../../assets/images/png/home/accelerate-inverse-2.webp";

const CardText = ({ className, title, subTitle }) => {
  return (
    <div
      className={`${
        className || "bg-white"
      } text-default px-8 lg:px-12 py-16 lg:py-6 flex flex-col justify-center`}
    >
      <h2 className="font-mono text-6xl font-semibold">{title}</h2>
      <p className="w-10/12 pt-2 text-base lg:text-lg">{subTitle}</p>
    </div>
  );
};

const CardImage = ({ image }) => {
  return (
    <div className="">
      <img src={image} alt="Accelerate" />
    </div>
  );
};

const OurNumberSection = () => {
  return (
    <section className="pt-20 lg:pt-24 pb-24 lg:pb-28 about-accelerate-section">
      <div className="container mx-auto px-4">
        <div className="w-full">
          <Animate.Fade bottom>
            <div className="flex flex-wrap justify-between items-end">
              <div className="w-6/12 mx-auto text-center">
                <h2 className="text-primary text-3xl lg:text-4xl xl:text-5xl xl:leading-tight font-mono font-semibold">
                  Our Numbers
                </h2>
              </div>
            </div>

            <div className="w-full lg:w-11/12 xl:w-10/12 mx-auto mt-14 lg:mt-20 grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4">
              <CardText title={"110k+"} subTitle="Students Trained" />
              <CardImage image={AccImage1} />

              <CardText
                className={"bg-green"}
                title={"85%"}
                subTitle="Hiring rate of Utiva Learners"
              />
              <CardImage image={AccImage2} />

              <CardImage image={AccImage3} />
              <CardText
                className={"bg-primary-light-2"}
                title={"10"}
                subTitle="Learning Programs"
              />
              <CardImage image={AccImage4} />

              <CardText
                className={"bg-secondary"}
                title={"30"}
                subTitle="Countries"
              />
            </div>
          </Animate.Fade>
        </div>
      </div>
    </section>
  );
};

export default OurNumberSection;
